import LocaleStrings from "Languages";

export default function () {
  return [
    {
      iconName: "wizard",
      title: LocaleStrings.course_submenu_title1,
      description: LocaleStrings.course_submenu_description1,
    },
    {
      iconName: "course",
      title: LocaleStrings.course_submenu_title2,
      description: LocaleStrings.course_submenu_description2,
    },
    {
      iconName: "quiz",
      title: LocaleStrings.course_submenu_title3,
      description: LocaleStrings.course_submenu_description3,
    },
  ];
}
